import {
	ChangeDetectionStrategy,
	Component,
	EventEmitter,
	Input,
	OnChanges,
	Output,
	SimpleChanges
} from '@angular/core';

@Component({
	selector: 'app-empty-table',
	templateUrl: './empty-table.component.html',
	styleUrl: './empty-table.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class EmptyTableComponent implements OnChanges {
	@Input() type:
		'users' |
		'roles' |
		'rules' |
		'clients' |
		'currencies' |
		'history-logs' |
		'rates' |
		'import-rates' |
		'md-task' |
		'si-task' |
		'sources' |
		'system-codes' |
		'translation-rules' |
		'camara-rules' | undefined;
	@Input() showImg = true;
	@Input() disabled = false;

	@Output() readonly newUser = new EventEmitter();
	@Output() readonly newRole = new EventEmitter();
	@Output() readonly newRule = new EventEmitter();
	@Output() readonly newClient = new EventEmitter();
	@Output() readonly newSource = new EventEmitter();
	@Output() readonly newCurrency = new EventEmitter();
	@Output() readonly newRate = new EventEmitter();
	@Output() readonly importRates = new EventEmitter();
	@Output() readonly newMdtask = new EventEmitter();
	@Output() readonly newSiTask = new EventEmitter();
	@Output() readonly newSystemCode = new EventEmitter();
	@Output() readonly newTranslationRule = new EventEmitter();
	@Output() readonly newCamaraRule = new EventEmitter();

	title = '';
	subTitle = '';
	buttonText = '';
	optionalButtonText = '';
	icon = '';

	constructor() {}

	ngOnChanges(changes: SimpleChanges): void {
		if (changes['type']) {
			switch (this.type) {
				case 'users':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'users_roles.users.create';
					this.icon = 'icon-plus';
					break;
				case 'roles':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'users_roles.roles.create';
					this.icon = 'icon-plus';
					break;
				case 'rules':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'rules.add';
					this.icon = 'icon-plus';
					break;
				case 'clients':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'clients.add';
					this.icon = 'icon-plus';
					break;
				case 'sources':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'sources.add';
					this.icon = 'icon-plus';
					break;
				case 'currencies':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'currencies.add';
					this.icon = 'icon-plus';
					break;
				case 'rates':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'rates.add';
					this.icon = 'icon-plus';
					break;
				case 'import-rates':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'import_rates.add';
					this.icon = 'icon-plus';
					break;
				case 'md-task':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'manual_dipping.add';
					this.icon = 'icon-plus';
					break;
				case 'si-task':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'simulation.add';
					this.icon = 'icon-plus';
					break;
				case 'system-codes':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'system_codes.add';
					this.icon = 'icon-plus';
					break;
				case 'translation-rules':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'translation_rules.add';
					this.icon = 'icon-plus';
					break;
				case 'camara-rules':
					this.title = '';
					this.subTitle = '';
					this.buttonText = 'camara_rules.create_rule';
					this.icon = 'icon-plus';
					break;
				default:
					break;
			}
		}
	}

	clicked(): void {
		switch (this.type) {
			case 'users':
				this.newUser.emit(undefined);
				break;
			case 'roles':
				this.newRole.emit(undefined);
				break;
			case 'rules':
				this.newRule.emit(undefined);
				break;
			case 'clients':
				this.newClient.emit(undefined);
				break;
			case 'sources':
				this.newSource.emit(undefined);
				break;
			case 'currencies':
				this.newCurrency.emit(undefined);
				break;
			case 'rates':
				this.newRate.emit(undefined);
				break;
			case 'import-rates':
				this.importRates.emit(undefined);
				break;
			case 'md-task':
				this.newMdtask.emit(undefined);
				break;
			case 'si-task':
				this.newSiTask.emit(undefined);
				break;
			case 'system-codes':
				this.newSystemCode.emit(undefined);
				break;
			case 'translation-rules':
				this.newTranslationRule.emit(undefined);
				break;
			case 'camara-rules':
				this.newCamaraRule.emit(undefined);
				break;
			default:
				break;
		}
	}

	optionalButtonClicked(): void {
		switch (this.type) {
			default:
				break;
		}
	}
}